<template>
    <div class="introduction-swipper-container">
        <CommonComponentsTopicSection type="Introduction" />
        <div class="global-limited-1360px-container">
            <div class="introduction-swipper-card">
                <div class="card-top" style="background-repeat: no-repeat">
                    <div class="card-top-title gasp-text">{{ $t('global_company_synopsis') }}</div>
                    <div class="card-top-text bottom gasp-text" v-html="$t(data.cardTopTextTop)" />
                </div>

                <div class="card-bottom">
                    <div class="card-bottom-purpose">
                        <div class="vision">
                            <div class="vision-title gasp-text">{{ $t('global_company_vision') }}</div>
                            <div class="vision-text gasp-text" v-html="$t(data.cardTopTextBottom)" />
                        </div>
                        <div class="values">
                            <div class="values-title gasp-text">{{ $t('global_company_values') }}</div>
                            <div class="values-text">
                                <div v-for="(item, index) in purposeList" :key="index" class="purpose-body">
                                    <div class="purpose-body-icon">
                                        <img :src="item.imgUrl" alt="" />
                                    </div>
                                    <div class="purpose-body-text gasp-text" item.text>{{ $t(item.text) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import bluebg from '@assets/imgs/AboutUs/Introduction/Swipper/bluebg.jpg';
    import bluebgmobile from '@assets/imgs/AboutUs/Introduction/Swipper/bluebgmobile.jpg';
    import { matchMobile } from '~~/composables/useMatchRules.ts';

    import custom from '@assets/imgs/AboutUs/Introduction/Swipper/custom.png';
    import ultimate from '@assets/imgs/AboutUs/Introduction/Swipper/ultimate.png';
    import multielement from '@assets/imgs/AboutUs/Introduction/Swipper/multielement.png';
    import development from '@assets/imgs/AboutUs/Introduction/Swipper/development.png';

    const data = {
        bluebg,
        bluebgmobile,
        cardTopTextTop: 'global_aboutus_introduction_swipper_card_top_text_top',
        cardTopTextBottom: 'global_aboutus_introduction_swipper_card_top_text_bottom',
    };
    const purposeList = [
        {
            imgUrl: custom,
            text: 'global_aboutus_introduction_swipper_card_top_text_bottom_des1',
        },
        {
            imgUrl: ultimate,
            text: 'global_aboutus_introduction_swipper_card_top_text_bottom_des2',
        },
        {
            imgUrl: multielement,
            text: 'global_aboutus_introduction_swipper_card_top_text_bottom_des3',
        },
        {
            imgUrl: development,
            text: 'global_aboutus_introduction_swipper_card_top_text_bottom_des4',
        },
    ];

    onMounted(() => {
        const ifMatched = matchMobile();
        const bg = document.querySelector('.introduction-swipper-card') as HTMLElement;
        if (!ifMatched) {
            bg.style.backgroundImage = `url(${data.bluebg})`;
        } else {
            bg.style.backgroundImage = `url(${data.bluebgmobile})`;
        }
        addTextScrollLine('.gasp-text');
    });
</script>

<style lang="less" scoped>
    :deep(.aboutus-topic-section-title-container) {
        @media (max-width: @screen-mobile-width) {
            bottom: .convert(127px) [ @vw-mobile] !important;
            white-space: nowrap !important;
            align-items: center !important;
            .aboutus-topic-section-title {
                font-size: .convert(32px) [ @vw-mobile] !important;
            }
        }
    }

    .introduction-swipper-container {
        font-family: Montserrat, 'HarmonyOS Sans SC';
        font-style: normal;
        .introduction-swipper {
            &-card {
                // width: 100%;
                // height: .convert(412px) [ @vw]; //412 974px
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
                background: #161616;
                margin-top: .convert(60px) [ @vw];
                overflow: hidden;
                font-family: 'HarmonyOS Sans SC';
                overflow: hidden;
                background-size: cover;
                background-repeat: no-repeat;

                .card-top {
                    width: 100%;
                    // height: .convert(412px) [ @vw];

                    padding: .convert(80px) [ @vw];
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    @media (max-width: @screen-mobile-width) {
                        padding: .convert (30px) [ @vw-mobile];
                        padding-bottom: 40px;
                    }
                    &-title {
                        font-size: .convert(36px) [ @vw];
                        font-weight: 400;
                        font-style: normal;
                        margin-bottom: .convert(30px) [ @vw];
                        @media (max-width: @screen-mobile-width) {
                            font-size: .convert(16px) [ @vw-mobile];
                        }
                    }
                    &-text {
                        font-size: .convert(24px) [ @vw]; //20px
                        font-style: normal;
                        font-weight: 400;
                        line-height: 180%; /* 36px */
                        @media (max-width: @screen-mobile-width) {
                            font-size: .convert(14px) [ @vw-mobile];
                        }
                    }
                }
                .card-bottom {
                    padding: .convert(80px) [ @vw];
                    padding-top: 0;
                    @media (max-width: @screen-mobile-width) {
                        padding: .convert(30px) [ @vw-mobile];
                        padding-top: 0;
                        padding-bottom: 14px;
                    }

                    &-purpose {
                        display: flex;
                        @media (max-width: @screen-mobile-width) {
                            display: block;
                        }
                        .vision {
                            width: .convert(405px) [ @vw];
                            border-right: 1px solid rgba(255, 255, 255, 0.6);
                            @media (max-width: @screen-mobile-width) {
                                width: 100%;
                                border: unset;
                            }
                            &-title {
                                font-size: .convert(36px) [ @vw];
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                                margin-bottom: 88px;
                                @media (max-width: @screen-mobile-width) {
                                    font-size: .convert(16px) [ @vw-mobile];
                                    margin-bottom: 15px;
                                }
                            }
                            &-text {
                                font-size: .convert(24px) [ @vw];
                                font-style: normal;
                                font-weight: 400;
                                line-height: 180%;
                                @media (max-width: @screen-mobile-width) {
                                    font-size: .convert(14px) [ @vw-mobile];
                                    line-height: normal;
                                }
                            }
                        }
                        .values {
                            margin-left: .convert(90px) [ @vw];
                            width: .convert(715px) [ @vw];
                            @media (max-width: @screen-mobile-width) {
                                margin-left: 0;
                                width: 100%;
                                margin-top: .convert (40px) [ @vw-mobile];
                            }
                            &-title {
                                font-size: .convert(36px) [ @vw];
                                font-style: normal;
                                font-weight: 400;
                                line-height: normal;
                                margin-bottom: .convert(60px) [ @vw];
                                @media (max-width: @screen-mobile-width) {
                                    font-size: .convert(16px) [ @vw-mobile];
                                    font-weight: 400;
                                    margin-bottom: .convert (15px) [ @vw-mobile];
                                }
                            }
                            &-text {
                                display: flex;
                                justify-content: space-between;
                                @media (max-width: @screen-mobile-width) {
                                    flex-wrap: wrap;
                                }
                                .purpose-body {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    @media (max-width: @screen-mobile-width) {
                                        flex-direction: row;
                                        justify-content: center;
                                        margin-bottom: 25px;
                                    }
                                    &-icon {
                                        width: .convert(80px) [ @vw];
                                        height: .convert(80px) [ @vw];
                                        @media (max-width: @screen-mobile-width) {
                                            width: 36px;
                                            height: 36px;
                                            margin-right: 15px;
                                        }
                                        img {
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }
                                    &-text {
                                        width: .convert(96px) [ @vw];
                                        margin-top: .convert(30px) [ @vw];
                                        color: #fff;
                                        font-size: .convert(24px) [ @vw];
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: normal;
                                        text-align: center;
                                        @media (max-width: @screen-mobile-width) {
                                            width: auto;
                                            text-align: start;
                                            margin-top: 0;
                                            font-size: .convert(16px) [ @vw-mobile];
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        :lang(en) {
            .card-bottom {
                &-purpose {
                    .vision {
                        &-text {
                            @media (max-width: @screen-mobile-width) {
                                font-size: .convert(16px) [ @vw-mobile];
                                line-height: normal;
                            }
                        }
                    }
                    .values {
                        .values-text {
                            .purpose-body {
                                &-text {
                                    font-size: .convert(20px) [ @vw];
                                    width: .convert(162px) [ @vw];
                                    @media (max-width: @screen-mobile-width) {
                                        width: auto;
                                        margin-top: 0;
                                        font-size: .convert(16px) [ @vw-mobile];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
